import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink, Navigate } from 'react-router-dom';
import { t } from '@/core/localization';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, linkTo, title, claimIds } = appSections.stockReceipt;
export const stockReceiptRoutes = [
    { path: rootPath, element: _jsx(Navigate, { to: "invoices", replace: true }) },
    {
        path: rootPath,
        lazy: async () => {
            const { StockReceiptContainer } = await import('@/admin/modules/stockReceipt');
            return {
                element: (_jsx(ProtectedRoute, { claims: claimIds, children: _jsx(StockReceiptContainer, {}) })),
            };
        },
        handle: {
            crumb: () => _jsx(NavLink, { to: linkTo, children: title }),
        },
        children: [
            {
                path: ':tab',
                lazy: async () => {
                    const { StockReceipt } = await import('@/admin/modules/stockReceipt');
                    return { Component: StockReceipt };
                },
                handle: {
                    crumb: ({ params }) => (_jsx(NavLink, { to: `${linkTo}/${params.tab}`, children: params.tab === 'invoices'
                            ? t('incoming.label')
                            : params.tab === 'verification'
                                ? t('verification.label')
                                : 'UNKNOWN' })),
                },
            },
            {
                path: ':tab/:invoiceId',
                lazy: async () => {
                    const { Invoice } = await import('@/admin/modules/stockReceipt/components/Invoice');
                    return { Component: Invoice };
                },
                handle: {
                    crumb: ({ params }) => (_jsx(NavLink, { to: `${linkTo}/${params.tab}`, relative: "path", children: t('incoming.label') })),
                },
            },
        ],
    },
];
